import { createSlice, PayloadAction} from "@reduxjs/toolkit";
import * as _state from "./DartsScoring.state";
import * as _thunk from "./DartsScoring.thunk";
import * as _types from "./DartsScoring.types";
import * as _helper from "./DartsScoring.helper";
import { DartsGameStatus } from "../../../common/types/DartsGameStatuses";
import IDartsGameIdType from "../../../common/interfaces/IDartsGameIdType";
import { RequestStatus } from "../../../common/enums/RequestStatus.enum";


const initialState: _state.DartsScoringState = {
    game: {} as _state.DartsGameState,
    playerId: null,
    playerIndex: null,
    dateStart: null,
    isThrowAllowed: true,
    btnUndoDisabled: true,
    currentGameLoader: false
}

export const DartsScoringSlice = createSlice({
    name: 'dartsCurrentGame',
    reducers: {
        syncDartsGameStatus: (state, action: PayloadAction<DartsGameStatus>) => {
            state.game.status = action.payload;
        },
        syncDartsGameIdType: (state, action: PayloadAction<IDartsGameIdType>) => {
            state.game.gameId = action.payload.gameId;
            state.game.gameType = action.payload.gameType;
        },
        syncDartsGameStatusAndPlayerId: (state, action: PayloadAction<_types.DartsGameStatusPayload>) => {
            state.game.status = action.payload.status;
            state.playerId = action.payload.playerId;
        },
        syncCurrentPlayerId: (state, action: PayloadAction<number>) => {
            state.playerId = action.payload;
        }
    },
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(_thunk.initDartsGameScoring.pending, state => {
                _helper.setUI(state, RequestStatus.pending);
                state.currentGameLoader = true;
            })
            .addCase(_thunk.initDartsGameScoring.rejected, state => {
                _helper.setUI(state, RequestStatus.rejected);
            })
            .addCase(_thunk.initDartsGameScoring.fulfilled, (state, action) => {
                _helper.applyDartsGameScoringInit(state, action.payload, action.meta.arg);
                state.currentGameLoader = false;
                _helper.setUI(state, RequestStatus.fulfilled);
            })
            .addCase(_thunk.setDartsGameStatus.pending, state => {
                _helper.setUI(state, RequestStatus.pending);
            })
            .addCase(_thunk.setDartsGameStatus.rejected, state => {
                _helper.setUI(state, RequestStatus.rejected);
            })
            .addCase(_thunk.setDartsGameStatus.fulfilled, (state, action) => {
                _helper.applyDartsGameScoring(state, action.payload);
                //if (action.meta.arg.status === DartsGameStatus.Walkover) {
                //    syncDartsGameStatusAndPlayerId(action.meta.arg);
                //} else {
                //    syncDartsGameStatus(action.meta.arg.status);
                //}
                //state.game.legs = action.payload.legs;
                //state.game.turnScores = action.payload.turnScores;
                //state.game.timeline = [...state.game.timeline, ...action.payload.timeline]
                //state.game.lastTurns = action.payload.lastTurns;
                //state.game.status = action.payload.status;
                //state.playerId = action.payload.playerId;
                //state.playerIndex = action.payload.playerIndex;
                _helper.setUI(state, RequestStatus.fulfilled);
            })
            .addCase(_thunk.setFirstPlayer.rejected, state => {
                _helper.setUI(state, RequestStatus.rejected);
            })
            .addCase(_thunk.setFirstPlayer.pending, state => {
                _helper.setUI(state, RequestStatus.pending);
            })
            .addCase(_thunk.setFirstPlayer.fulfilled, (state, action) => {
                //const {gameType, gameData} = action.meta.arg;
                //state.currentPlayerId = gameData.playerId;
                //state.game.playerId = gameData.playerId
                state.game.timeline = action.payload;
                _helper.setUI(state, RequestStatus.fulfilled);
            })
            .addCase(_thunk.doThrow.rejected, state => {
                _helper.setUI(state, RequestStatus.rejected);
            })
            .addCase(_thunk.doThrow.pending, state => {
                _helper.setUI(state, RequestStatus.pending);
            })
            .addCase(_thunk.doThrow.fulfilled, (state, action) => {
                state.playerId = action.payload.playerId;
                state.btnUndoDisabled = false;
                state.isThrowAllowed = true;
                state.currentGameLoader = false;
                state.game.lastTurns = action.payload.lastTurns

                if (action.payload.status === DartsGameStatus.PreEnd) {
                    state.game.status = action.payload.status;
                }
                if (action.payload.legs !== null) {
                    // @ts-ignore
                    state.game.legs = action.payload.legs;
                }
                if (action.payload.turnScores) {
                    state.game.turnScores = action.payload.turnScores
                }
                state.game.timeline = [...state.game.timeline, ...action.payload.timeline]
                _helper.setUI(state, RequestStatus.fulfilled);
            })

            .addCase(_thunk.undoLastAction.pending, state => {
                _helper.setUI(state, RequestStatus.pending);
            })
            .addCase(_thunk.undoLastAction.fulfilled, (state, action) => {
                const { scoring, requestMeta } = action.payload;
                _helper.applyDartsGameScoringInit(state, scoring, requestMeta);
                _helper.setUI(state, RequestStatus.fulfilled);
            })
            .addCase(_thunk.undoLastAction.rejected, state => {
                _helper.setUI(state, RequestStatus.rejected);
            })

            .addCase(_thunk.doubleAttempt.pending, state => {
                _helper.setUI(state, RequestStatus.pending);
            })
            .addCase(_thunk.doubleAttempt.fulfilled, (state, action) => {
                state.game.timeline.forEach((item) => {
                    if (item.id === action.meta.arg.throwId) {
                        item.doubleAttempt = action.payload;
                    }
                })
                _helper.setUI(state, RequestStatus.fulfilled);
            })
            .addCase(_thunk.doubleAttempt.rejected, state => {
                _helper.setUI(state, RequestStatus.rejected);
            })
    }
})
export const {
    syncDartsGameStatus,
    syncDartsGameIdType,
    syncDartsGameStatusAndPlayerId,
} = DartsScoringSlice.actions;

export default DartsScoringSlice.reducer;

/*
setDartsGameStatusLocal ��������� ���������� (������ reducer) ���������� UI ��� draft-������
setDartsGameStatusFulfilled ����������� ���������� (� extraReducers) ��������� createAsyncThunk
setDartsGameStatusPending ������ ������� ������ ��������
setDartsGameStatusRejected ������ ������� ������ API
setDartsGameStatusOptimistic � ���� ���������� ������ �� ������ �������
setDartsGameStatusFromServer � ���� ������ �������� �� API
applyDartsGameStatus � ���� ���������� ���������
syncDartsGameStatus � ���� ��������������� � ��������
*/